export function tableScrolling() {
    const tableScrollingContainer = $(".table-scrolling");

    $(window).on("load resize", function () {
        tableScrollingContainer.each(function (){
            const table = $(this).find("table");
            const holder = $(this).find(".holder");

            if (!$(this).find(".clone").length) {
                const table = $(this).find("table");
                const tableClone = table.clone().addClass("clone");

                $(holder).append(tableClone);
            }

            holder.on("scroll", function (){
                $(this).closest(".table-scrolling")[`${$(this).scrollLeft() > 0 ? "add":"remove"}Class`]("scrolling");
            });
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tableScrolling.js